










import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'splitter' })
export default class SplitterComponent extends Vue {
}
